import TTLink, { type LinkOptions } from '@tiptap/extension-link';
import { AutoColourLinkPlugin } from './autoColourLinkPlugin';

const linkConfiguration: Partial<LinkOptions> = {
  openOnClick: true,
  autolink: true,
  defaultProtocol: 'https',
  protocols: ['http', 'https', 'mailto'],
  isAllowedUri: (url, ctx) => {
    try {
      // construct URL
      const parsedUrl = url.includes(':')
        ? new URL(url)
        : new URL(`${ctx.defaultProtocol}://${url}`);

      // use default validation
      if (!ctx.defaultValidate(parsedUrl.href)) {
        return false;
      }

      // disallowed protocols
      const disallowedProtocols = ['ftp', 'file'];
      const protocol = parsedUrl.protocol.replace(':', '');

      if (disallowedProtocols.includes(protocol)) {
        return false;
      }

      // only allow protocols specified in ctx.protocols
      const allowedProtocols = ctx.protocols.map((p) =>
        typeof p === 'string' ? p : p.scheme,
      );

      if (!allowedProtocols.includes(protocol)) {
        return false;
      }

      // disallowed domains
      // const disallowedDomains = ["example-phishing.com", "malicious-site.net"];
      // const domain = parsedUrl.hostname;

      // if (disallowedDomains.includes(domain)) {
      //   return false;
      // }

      // all checks have passed
      return true;
    } catch {
      return false;
    }
  },
  shouldAutoLink: (url) => {
    try {
      // construct URL
      const parsedUrl = url.includes(':')
        ? new URL(url)
        : new URL(`https://${url}`);

      // only auto-link if the domain is not in the disallowed list
      const disallowedDomains = [
        'example-no-autolink.com',
        'another-no-autolink.com',
      ];
      const domain = parsedUrl.hostname;

      return !disallowedDomains.includes(domain);
    } catch {
      return false;
    }
  },
};

export const Link = TTLink.extend({
  // when the link colour changes, it keeps the original underline colour unless this updates as well as the span wrappr for the text
  addAttributes() {
    return {
      ...this.parent?.(),
      color: {
        default: null,
        parseHTML: (element) => element.style.color || null,
        renderHTML: (attributes) => {
          if (!attributes.color) return {};
          return { style: `color: ${attributes.color}` };
        },
      },
    };
  },
  addProseMirrorPlugins() {
    const plugins = this.parent?.() || [];

    return [...plugins, AutoColourLinkPlugin()];
  },
}).configure(linkConfiguration);
